<template>
  <div class="content Tabs">

     <b-tabs card v-model="tabIndex">

          <b-tab v-if="isElectric" :title="lang.tab_NewAssembly"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">
             <p>{{lang.infotext_1}}: {{selectedGenericPart}}</p>
             <b-form >

                <b-form-group id="input-group-PartNumber" :label="lang.label_PartNumber" label-for="input-2">
                  <b-form-input
                    class="input-PartNumber"
                    id="input-PartNumber"
                    v-model="form.PartNumber"
                    :placeholder="lang.placeholder_PartNumber"
                    size="sm"
                    required
                    aria-describedby="input-PartNumber-feedback"
                    :state="validation_PartNumber"
                  ></b-form-input>

                  <b-form-invalid-feedback id="input-PartNumber-feedback" :state="validation_PartNumber">
                    {{lang.validinfo_PartNumber}}
                  </b-form-invalid-feedback>
                </b-form-group> 
              </b-form >
               
   

            </b-container>
          </b-tab>
          <b-tab v-if="!isElectric" :title="lang.tab_AssignAssembly"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">
              <p>{{lang.infotext_2}} <b>{{selectedGenericPart}}</b> {{lang.infotext_3}}:</p>
              
                <label for="input_Quantity">{{lang.label_Quantity}}: </label>
                <b-form-input id="input_Quantity" v-model="Quantity" type="number" class="input-Quantity" size="sm" min="1" max="100" inline></b-form-input>
                

               <AssemblyTableComponent :lang="lang.AssemblyTable"></AssemblyTableComponent>
   

            </b-container>
          </b-tab>
         

        </b-tabs>
       

  </div>

</template>
<script>
import { mapGetters } from 'vuex'



import AssemblyTableComponent from '@/components/shared/AssemblyTableComponent'


export default {
  name: "Content",
  components: {
    AssemblyTableComponent,


  },
  props:{
    lang: Object,

  },
  data () {
    return {
      
      tabIndex: 0,
      form: {
        
        PartNumber: '',
        
      },
      Quantity: 1,
      colorVariant: ""
    }
  },
  computed: {
    ...mapGetters({
      

    }),
    
    validation_PartNumber() {
      
      
      if (this.form.PartNumber.length == 0){
        return null;
      }
      return this.form.PartNumber.length > 0
    },
    selectedGenericPart(){
      let pm = "";  
      for (let prop in this.$store.getters.selectedRows[0]){
        
        if (this.$store.getters.selectedRows[0][prop].type == "part number"){
          pm = this.$store.getters.selectedRows[0][prop].value.display;
          break;
        }
      }    

      return pm;
    },
    typeOfPart(){
      let type = "Electric";  
      for (let prop in this.$store.getters.selectedRows[0]){
        
        if (this.$store.getters.selectedRows[0][prop].type == "type"){
          type = this.$store.getters.selectedRows[0][prop].value.display;
          break;
        }
      }    

      return type;
    },
    isElectric(){
      if (this.typeOfPart == "Electric"){
        return true;
      }else{
        return false;
      }
    },
    selectedRows(){
      return this.$store.getters.selectedRows;
    },
    currentUser(){
      return this.$store.getters.currentUser;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        
        
        return "light";
      }else{
        
        return "dark";
      }
      
    },
    
  },
  created () {
    

  },

  updated() {
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewAssemblyForm", this.form);
    

  },
  watch: {
    Quantity: function (newVal, oldval) {
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAssemblyQuantity", this.Quantity);
    }
    
  

  },
  methods:{
    
    

  },
  
}
</script>

<style lang="scss">

  .Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
    .container{
      margin-left: 0px;
    }
    .input-PartNumber{
      max-width: 300px;
    }
    .input-Quantity{
      max-width: 100px;
      display: inline;
    }
    
  }




</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartAssembly/Middle/Content/Content.vue